<template>
  <div class="agreement">
    <div class="top-bar">信息条款</div>
    <div class="agree-list">
      <div class="agree-list-title">
        投保信息及条款
      </div>
      <ul class="step_pane">
        <li v-for="(item,index) in agreeList"  @click="toContent(item)">
          <a class="button" style="color: #008a61;border-left: #44dc00 4px solid;padding-left: 10px" >
            <label>{{ item.provisionName }}</label>
          </a>
          <span :class="['agree-status',item.agree==1?'readed':'']">{{item.agree==1?'已阅知':'未阅读'}}</span>
        </li>
      </ul>
    </div>

    <div class="agreeBtn" v-if="isApplicant==1" ><input type="checkbox" ref="checkbox" v-model="checked" name="readInfo" value="" @change="checkReadResult"> <span>我已阅读并同意以上信息及条款</span>  </div>
    <div class="msg-view" v-if="isApplicant==1" >
      <div class="msg-view-label">投保验证码</div>
      <input class="msg-view-input" v-model="code" @input="changeInput" placeholder="请输入验证码" maxlength="10" type="number">
      <div class="rtnMsg">{{ rtnMsg }}</div>
    </div>

    <div class="buttom" v-if="isApplicant==1" @click="commit">确 认</div>
    <div class="noApplicant" v-if="isApplicant!=1">需投保人阅读并确认同意以上投保信息及条款</div>
    <div class="mask" v-if="showDialog">
      <div class="dialog">
        <div class="dialog-title">提示</div>
        <div class="dialog-text" >{{dialogMsg}}</div>
        <div class="dialog-btn" @click="showDialog = false">确 认</div>
      </div>
    </div>
  </div>
</template>

<script>
var obj = require("@/api/api.js");

export default {
  name: "agreement",
  created() {
    this.proposalno = this.$route.query.proposalno
    this.phoneno = this.$route.query.phoneno
    this.query()
  },
  data(){
    return{
      proposalno:'',
      isApplicant:'',
      phoneno:'',
      agreedNum:0,
      showDialog:false,
      dialogMsg:'',
      rtnMsg:'',
      code:'',
      checked:false,
      agreeList:[]
    }
  },
  methods:{
    query(){
      let proposalProvisionsH5List = obj.proposalProvisionsH5List
      let param = {
        "phone":  this.$route.query.phone,
        "proposalno":  this.$route.query.ProposalNo,
        "type": ''
      }
      this.$http
        .post(proposalProvisionsH5List, param)
        .then((res) => {
          var result = res.data;
          if (result.code == "0000") {
            this.agreeList = result.data.proposalProvisionsVos
            this.isApplicant = result.data.isApplicant
            this.getReadrecord()
          }
        });
    },
    checkReadResult(e){
      console.log()
      if(this.checked&&this.agreedNum<this.agreeList.length){
        this.checked = false
        this.$refs.checkbox.checked = false
        this.dialogMsg = '请点击进入页面阅读并点击【已阅知】以上投保信息及条款'
        this.showDialog = true
        this.$forceUpdate()
        return
      }

      console.log(this.checked)
    },
    getReadrecord(){
      this.$http.post(obj.getReadrecordByProposalno,{proposalNo:this.$route.query.ProposalNo}).then(res=>{
        if(res.data.code=='0000'){
          if(res.data.data.length>0){
            let _list = res.data.data
            this.agreedNum = _list.length
            this.agreeList.forEach(item=>{
              console.log(_list.findIndex(val=>{ return val.eletype==item.provisionType}))
              if(_list.findIndex(val=>{ return val.eletype==item.provisionType})>-1){
                item.agree = 1
              }else{
                item.agree = 0
              }
            })
            this.$forceUpdate()
          }
        }

      })
    },
    changeInput(){
      this.rtnMsg = ''
    },
    commit(){
      if(!this.checked){
        this.showDialog = true
        this.dialogMsg = '请勾选 "我已阅读并同意以上信息及条款"'
        this.$forceUpdate()
        return
      }
      if(this.code==''){
        this.rtnMsg = '请输入验证码'
        return
      }
      this.$http.post(obj.saveIssueCode,{    "issuecode": this.code,"proposalno": this.$route.query.ProposalNo}).then(res=>{
        console.log(res.data.rtnCode)

        if(res.data.rtnCode=='0000'){
          this.showDialog = true
          this.dialogMsg = '验证成功'
        }else{
          this.rtnMsg = res.data.rtnMsg
        }
      })
    },
    toContent(row){
      this.$router.push({
        path:'/agreement/content',
        query:{
          fileName:'InsuranceClause',
          phoneno:this.$route.query.phone,
          name:row.provisionName,
          proposalno:this.$route.query.ProposalNo,
          isApplicant:this.isApplicant,
          agreed:row.agree,
          type:row.provisionType
        }
      })
    }
  }
}
</script>

<style scoped>

.agreement{
  width: 100vw;
  height: 100vh;
  background: linear-gradient(#ebffe5,#ffffff 80%)
}
.top-bar{
  width: 100vw;
  height: 45px;
  background: #44dc00;
  background:linear-gradient(#44dc00, #36af00);
  font-size: 16px;
  text-align: center;
  line-height: 45px;
  color: #FFFFFF;
}
.agree-list{
  width: calc( 100vw - 40px);
  margin: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
}
.agree-list-title{
  position: relative;
  height: 40px;
  border-radius: 5px 5px 0 0;
  background-color: #44dc00;
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}
.step_pane{
  overflow: hidden;
  background-color: #FFFFFF;
}
.step_pane li {
  position: relative;
  clear: both;
  padding: 0 20px;
  height: 40px;
  border-bottom: 1px solid #d9d9d9;
  vertical-align: middle;
  font-size: 14px;
  line-height: 40px;
}
.step_pane li:last-child {
  border-bottom: none;
}
.agreeBtn{
  color: #25a300;font-size: 15px;
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.agreeBtn input{
  margin-right: 10px;
}

.buttom{
  margin: 40px 20px 0 20px;
  width: calc( 100vw - 40px);
  height: 45px;
  border: 0;
  border-radius: 5px;
  text-align: center;
  line-height: 45px;
 box-shadow: 6px 6px 7px 1px #bbfba1;
  background:linear-gradient(45deg,#44dc00, #36af00);
  color: #fff;
  font-size: 16px;
  -webkit-appearance: none;
}
.noApplicant {
  width: 100%;
  font-size: 14px;
  text-align: center;
  color: #8a8a8a;
}
.mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,.4);
}
.dialog{
  width: 80vw;
  height:auto;
  margin-left: 10vw;
  padding-bottom: 20px;
  margin-top: calc((100vh - 200px) / 3);
  background-color: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
}
.dialog-title{
  width: 100%;
  height: 40px;
  background-color: #44dc00;
  color: #FFFFFF;
  font-size: 14px;
  padding-left: 10px;
  line-height: 40px;
}
.dialog-text{
  font-size: 14px;
  width: 100%;
  line-height: 30px;
  padding:20px 10%;
  text-align: center;
  color: #f17300;
}
.dialog-btn{
  width: 50%;
  margin-left: 25%;
  height: 30px;
  color: #FFFFFF;
  background-color: #3bd800;
  text-align: center;
  border-radius: 2px;
  line-height: 30px;
  font-size: 14px;
}
.agree-status{
  float: right;
  color: #a1a3a6;
}
.agree-status.readed{
  color:  #3bd800;
}
.msg-view{
  width: calc( 100vw - 40px);
  margin: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  display: flex;
  font-size: 15px;
  position: relative;
}
.msg-view-label{
  padding: 10px 30px;
  flex-shrink: 0;
  color: #FFFFFF;
  background-color: #3bd800;
}
.msg-view-input{
  width: 100%;
  border: 1px solid #3bd800;
  padding: 0 20px;
  letter-spacing:4px;
  font-size: 12pt;
}
.msg-view-input::placeholder{
  color: #8eb483;
}
.rtnMsg{
  font-size: 15px;
  margin-left: 20px;
  position: absolute;
  color: red;
  bottom: -25px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Agreement/agreement.vue